import { translate } from "../../util/translate"

export const hostHeaders = [
  {
    text: translate['host.label.name'],
    value: 'name',
    width: 250,
  },
  {
    text: translate['host.label.username'],
    value: 'username',
    width: 200,
  },
  {
    text: translate['host.label.phone'],
    value: 'phone',
    width: 200,
  },
  // {
  //   text: translate['host.label.onboardingStep'],
  //   value: 'onboarding_step',
  //   width: 100,
  // },
  // {
  //   text: translate['host.label.startedOnboardingTrainingAt'],
  //   value: 'started_onboarding_training_at',
  //   width: 150,
  // },
  {
    text: translate['host.label.status'],
    value: 'status',
    width: 120,
  },
  {
    text: translate['host.label.integration'],
    value: 'id',
    width: 120,
  },
  {
    value: 'actions',
    align: 'end',
    width: 60,
  },
]

export const hostPaymentsHeaders = [
  {
    text: translate['host.label.type'],
    value: 'payment_type',
    width: 100,
  },
  {
    text: translate['host.label.transaction'],
    value: 'transaction_id',
    width: 100,
  },
  {
    text: translate['host.label.createdAt'],
    value: 'created_at',
    width: 155,
  },
  {
    text: translate['host.label.status'],
    value: 'transfer_status',
    width: 250,
  },
  {
    text: translate['host.label.total'],
    value: 'total',
    align: 'end',
    width: 150,
  },
]

export const hostServiceHistoryHeaders = [
  {
    text: translate['host.label.date'],
    value: 'date_created',
    width: '180px',
  },
  {
    text: translate['host.label.author'],
    value: 'author'
  },
  { text: '', value: 'data-table-expand' },
]

export const hostHistoryHeaders = [
  {
    text: translate['host.label.date'],
    value: 'date_created',
    width: '180px',
  },
  {
    text: translate['host.label.author'],
    value: 'author'
  },
  {
    text: translate['host.label.action'],
    value: 'action'
  },
  { text: '', value: 'data-table-expand' },
]
